// removed by extract-text-webpack-plugin
module.exports = {"readOnly":"src-components-about----socials-module---readOnly---1Zz3c","iconGroup":"src-components-about----socials-module---iconGroup---1-K6e","icon":"src-components-about----socials-module---icon---28ciI","email":"src-components-about----socials-module---email---3wL7F","socialsContainer":"src-components-about----socials-module---socialsContainer----PR73"};


//////////////////
// WEBPACK FOOTER
// ./src/components/about/socials.module.css
// module id = 321
// module chunks = 263791100135453